import React from "react";

/**
 * ArgusSecure wordmark — classical lockup.
 * Almond eye motif (hairline) + 1px vertical rule + ARGUS / SECURE small-caps serif.
 * Color is `currentColor` so it inherits from the surrounding text color,
 * which means it automatically switches between dark + light themes.
 * NEVER wrap in a card / pill / box.
 */
export default function Logo({ className = "", size = 28, withEye = true, color }) {
  const fill = color || "currentColor";
  const eyeWidth = Math.round(size * 1.6);
  const eyeHeight = Math.round(size * 0.85);
  return (
    <span
      className={`logo inline-flex items-center select-none ${className}`}
      data-testid="argus-logo"
      style={{ background: "transparent", border: "none", boxShadow: "none", gap: size * 0.45, color: fill }}
    >
      {withEye && (
        <svg
          width={eyeWidth}
          height={eyeHeight}
          viewBox="0 0 32 17"
          fill="none"
          aria-hidden="true"
          style={{ flexShrink: 0 }}
        >
          <path
            d="M1 8.5 C6 1.5, 26 1.5, 31 8.5 C26 15.5, 6 15.5, 1 8.5 Z"
            stroke="currentColor"
            strokeWidth="1.1"
            strokeLinejoin="round"
            fill="none"
          />
          <circle cx="16" cy="8.5" r="1.4" fill="currentColor" />
        </svg>
      )}
      {withEye && (
        <span
          aria-hidden="true"
          style={{
            display: "inline-block",
            width: 1,
            height: size * 0.95,
            background: "currentColor",
            opacity: 0.4,
          }}
        />
      )}
      <span
        className="wordmark-lockup"
        style={{
          display: "inline-flex",
          flexDirection: "column",
          alignItems: "flex-start",
          color: "currentColor",
          lineHeight: 1,
          paddingTop: 1,
        }}
      >
        <span
          style={{
            fontSize: size * 0.78,
            fontWeight: 500,
            fontFamily: "Cinzel, 'Trajan Pro', 'Cormorant Garamond', Georgia, serif",
            letterSpacing: "0.18em",
            lineHeight: 1,
          }}
        >
          ARGUS
        </span>
        <span
          style={{
            fontSize: Math.max(8, size * 0.28),
            fontWeight: 400,
            fontFamily: "Cinzel, 'Trajan Pro', Georgia, serif",
            letterSpacing: "0.34em",
            opacity: 0.7,
            marginTop: size * 0.08,
          }}
        >
          SECURE
        </span>
      </span>
    </span>
  );
}
